import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitTo',
  standalone: true
})
export class LimitToPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return value ? value.substring(0, args[0]) : value;
  }

}
